import { ReactNode, createContext, useContext } from "react";

import { wacToken } from "../foundations";

interface DarkThemeContextValue {
    isDarkTheme: boolean;
}

const DarkThemeContext = createContext<DarkThemeContextValue>({
    isDarkTheme: false
});

export const useDarkTheme = () => useContext(DarkThemeContext);

interface DarkThemeProviderProps {
    enabled: boolean;
    children: ReactNode;
}

const darkThemeStyles: React.CSSProperties = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    ["--wac-color-heading" as string]: wacToken("color.neutral.light0"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    ["--wac-color-body" as string]: wacToken("color.neutral.light0"),
    backgroundColor: wacToken("color.neutral.dark100")
};

export const DarkThemeProvider = ({
    enabled,
    children
}: DarkThemeProviderProps) => {
    return (
        <DarkThemeContext.Provider value={{ isDarkTheme: enabled }}>
            <div style={enabled ? darkThemeStyles : undefined}>{children}</div>
        </DarkThemeContext.Provider>
    );
};
